import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/coolblue.webp';
import screenshot_target from '../../../images/letterfunnel/tamarnetergans.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Tamar Neter-Gans"
      firstname="Tamar"
      companyname="RobotWise"
      competition="Bommetje en Mad Science"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/tamarnetergans.js